/**
 * Experiment setting for Decagon AI chatbot in the Help Center
 */
export const HELP_CENTER_AI_CHATBOT_240903 = 'HELP_CENTER_AI_CHATBOT_240903';
